export default __webpack_public_path__ + "static/media/KZ.T.08.2310.8c42b983.svg";